import {Inject, Injectable} from '@angular/core';
import { SearchFilterModel } from '@app/search/components/model/search-filter.model';
import { MapperService } from '@app/search/services/mapper.service';
import { SearchResultsModel } from '@app/search/components/model/search-results.model';
import { HttpService } from '@app/common/services/http.service';
import { APP_CONFIG } from '@app/common/services/config.service';
import { ErrorHandlerService } from '@app/common/services/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private static readonly POSSIBLE_FILTERS: SearchFilterModel[] = [
    // category filter
    // { name: 'Akce',     type: 'category', filter: { index: 'mpv-projects' },   color: '#3322ff' },
    // { name: 'Subjekt',  type: 'category', filter: { index: 'mpv-subjects' },   color: '#ff88ff' },
  ];

  constructor(
    private httpService: HttpService,
    private mapperService: MapperService,
    private errorHandlerService: ErrorHandlerService,
    @Inject(APP_CONFIG) private config: any,
  ) {
  }

  public findByQuery(
    filters: SearchFilterModel[],
    query: string,
    pageSize?: number,
    offset?: number,
    index = 'project,subject,parcel,title,geometric_plan,opinion,component,case'
  ): Promise<SearchResultsModel | void> {

    return this.httpService.call({
      path: 'open-search/search',
      method: 'GET',
      baseUrl: this.config.BACKEND_OPTIONS.restUrlSY,
      params: { q: encodeURIComponent(query), size: pageSize, from: offset, index: index }
    }).then(data => {
        return this.mapperService.mapToResults(data);
    }).catch(this.errorHandlerService.get);
  }

  public findFiltersByQuery(filters: SearchFilterModel[], query: string): Promise<SearchFilterModel[]> {
    const possibleFilters = SearchService.POSSIBLE_FILTERS.filter(filter => {
      // filtr, ktery uz je pouzity, dame pryc
      if (filters.find(f => filter.name === f.name)) {
        return false;
      }

      // pokud je pouzity nejaky filtr typu kategorie, tak zadny dalsi nenabizet
      if (filter.type === 'category' && filters.filter(f => f.type === 'category').length) {
        return false;
      }

      return true;
    });

    const promises = [];

    for (const filter of possibleFilters) {
      if (filter.type === 'category') {
        promises.push(
          this.httpService.call({
            path: 'open-search/search',
            method: 'GET',
            baseUrl: this.config.BACKEND_OPTIONS.restUrlSY,
            params: { q: encodeURIComponent(query), size: 1, from: 0, index: filter.filter.index }
          }).then(data => {
            filter.query = query;
            filter.resultCount = data.total;
            return filter;
          })
        );
      }
    }

    if (promises.length) {
      return Promise.all(promises);
    }
    return Promise.resolve([]);
  }
}
